export const fmt = {
  currency: (v) => v == null ? '—' : `$${Number(v).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
  large: (v) => {
    if (v == null) return '—';
    const n = Number(v);
    if (Math.abs(n) >= 1e12) return `$${(n / 1e12).toFixed(2)}T`;
    if (Math.abs(n) >= 1e9) return `$${(n / 1e9).toFixed(2)}B`;
    if (Math.abs(n) >= 1e6) return `$${(n / 1e6).toFixed(2)}M`;
    return `$${n.toLocaleString()}`;
  },
  pct: (v, decimals = 1) => v == null ? '—' : `${Number(v).toFixed(decimals)}%`,
  multiple: (v, suffix = 'x') => v == null ? '—' : `${Number(v).toFixed(1)}${suffix}`,
  change: (v) => v == null ? '—' : `${v >= 0 ? '+' : ''}${Number(v).toFixed(2)}%`,
};

export const colorByValue = (v, positiveIsGood = true) => {
  if (v == null) return 'var(--text-muted)';
  const positive = positiveIsGood ? v > 0 : v < 0;
  return positive ? 'var(--green)' : 'var(--red)';
};

export const WATCHLIST_KEY = 'freejini_watchlist';
export const getWatchlist = () => JSON.parse(localStorage.getItem(WATCHLIST_KEY) || '[]');
export const addToWatchlist = (symbol) => {
  const list = getWatchlist();
  if (!list.includes(symbol)) localStorage.setItem(WATCHLIST_KEY, JSON.stringify([...list, symbol]));
};
export const saveWatchlist = (list) => localStorage.setItem(WATCHLIST_KEY, JSON.stringify(list));
export const removeFromWatchlist = (symbol) => {
  localStorage.setItem(WATCHLIST_KEY, JSON.stringify(getWatchlist().filter(s => s !== symbol)));
};
export const isInWatchlist = (symbol) => getWatchlist().includes(symbol);
